import { IField, IFormFieldDefinition } from "../../interfaces/Fields";

export interface IFieldControl extends IFormFieldDefinition {
    id: string;
    label: string;
    maxlength: number;
    description: string;
    explanation: string;
    section: string;
    visibilityCondition: any[];

    customType?: string;
    subtype?: string;
    optionyes?: string;
    valueyes?: string;

    options?: any[];
    valueoptions?: any[];
    iconoptions?: any[];
    
    cssClass?: string;
    placeholder?: string;
    datasource?: string;
    groupCssClass?: string;
    checkBoxLabel?: string;
    inputcontrolstyle?: string;
    icon?: string;
    buttonMode?: string;
    hasPopover?: boolean;
    defaultValue?: string;
    summaryLabel?: string;
    fieldCssClass?: string;

    isAdresBlokField?: boolean;
    prefixVoorAdresblokVelden?: string;
    alwaysShowSummaryField?: boolean;
    attachEditLinkInSummary?: string;
}

export function createControl(field: IField, category: string): IFieldControl {
    return {
        name: field['@column'],
        label: field.properties?.fieldcaption || field['@column'],
        maxlength: field['@columnsize'] != null ? parseInt(field['@columnsize']) : null,
        description: field.properties?.fielddescription || '',
        explanation: field.properties?.explanationtext || '',
        validation: {},
        section: 'category-' + category,
        hasPopover: !!field.properties?.explanationtext,
        visibilityCondition: [],
        id: field['@guid'],
        defaultValue: field.properties?.defaultvalue || '',
        summaryLabel : field.settings?.SummaryLabel || '',
        fieldCssClass: field.properties?.fieldcssclass,
    };
}
